import { include, reverse } from 'named-urls';

/** Unauthenticated endpoints in the proxy API */
export const PROXY_API_ROUTES = {
  salesforce: include('/salesforce', {
    leads: include('leads', {
      base: '',
      v2: 'v2',
      ':leadID': include(':leadID', {
        progress: 'progress',
      }),
      insurance: 'insurance',
    }),
  }),
};

/** Utility function to quickly extract the URL string from the API routes object. To be used for API calls */
export const getProxyAPIRoute: typeof reverse = (route, params) => {
  const result = reverse(route, params);

  /** @note(juan): this is needed because named-urls always adds a / at the end of URLs. This is probably because its meant
   * to be used with react-router but we use it directly for API calls. We just remove this ending /
   */
  if (result.endsWith('/')) {
    return result.substring(0, result.length - 1);
  }
  return result;
};
